export type ChatStreamStatus = 'error' | 'ready' | 'streaming' | 'submitted';

export const hasChatActivity = (
  messages: ReadonlyArray<{ role: string }> | undefined,
): boolean => messages?.some((message) => message.role === 'user') ?? false;

export const isActiveChatStreamStatus = (
  status: ChatStreamStatus | null | undefined,
): status is 'streaming' | 'submitted' =>
  status === 'streaming' || status === 'submitted';

export const shouldAttemptStreamResume = ({
  conversationId,
  messages,
  status,
}: {
  conversationId: string | null | undefined;
  messages: ReadonlyArray<{ role: string }> | undefined;
  status: ChatStreamStatus;
}): boolean => {
  if (!hasChatActivity(messages)) {
    return false;
  }

  if (isActiveChatStreamStatus(status)) {
    return false;
  }

  if (status === 'error') {
    return true;
  }

  return Boolean(conversationId);
};
